import React from "react";
import PropTypes from "prop-types";
import RedirectingContainer from "./RedirectingContainer";
import CenteredProgress from "./CenteredProgress";
import TopLevelRouterContainer from "./TopLevelRouterContainer";
const App = props => {
  const { status } = props;

  if (status === "success") {
    return <TopLevelRouterContainer />;
  }

  if (status === "Server unreachable") {
    return <RedirectingContainer title={status} />;
  }

  if (status === "loading") {
    return <CenteredProgress />;
  }

  return <RedirectingContainer title={status} />;
};

App.propTypes = {
  config: PropTypes.object,
  status: PropTypes.string.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js